import acessoUsuario from './acessoUsuario';
import redefinicaoEmailUsuario from './redefinicao-email-usuario';
import acordo from './acordo';
import agendamento from './agendamento';
import ajusteVerba from './ajuste-verba';
import alcada from './alcada';
import anoFiscal from './ano-fiscal/ano-fiscal';
import anoFiscalRelatorio from './ano-fiscal/ano-fiscal-relatorio';
import apuracaoAcaoListagem from './apuracao-acao-listagem';
import apuracaoCrescimento from './apuracao-crescimento';
import apuracaoFixo from './apuracao-fixo';
import apuracaoGestao from './apuracao-gestao';
import apuracaoNegociacaoPreco from './apuracao-negociacao-preco';
import apuracaoPositivacao from './apuracao-positivacao';
import apuracaoReprocessamento from './apuracao-reprocessamento';
import apuracaoTabloide from './apuracao-tabloide';
import apuracoesVencidas from './apuracoes-vencidas';
import bloqueioSistema from './bloqueio-sistema';
import cacheManager from './cache-manager';
import carteiraCliente from './carteira-cliente/carteira-cliente';
import calendario from './calendario';
import cep from './cep';
import cidade from './cidade';
import centroCusto from './centro-custo';
import cliente from './cliente';
import clienteCarteiraImplicita from './carteira-cliente/cliente-carteira-implicita';
import configuracao from './configuracao';
import configuracaoNegociacao from './negociacao/configuracao-negociacao';
import configuracaoPlanejamento from './configuracao-planejamento';
import configuracaoWorkflowAprovacao from './configuracao-workflow-aprovacao';
import configuracaoWorkflowContrato from './configuracao-workflow-contrato';
import contaCorrente from './conta-corrente';
import contrato from './contrato';
import contratoLoja from './contrato-loja';
import controladorTrade from './controlador-trade/controlador-trade';
import dashboardApuracao from './dashboard-apuracao';
import dashboardGerencial from './dashboard-gerencial';
import dashboardNegociacao from './dashboard-negociacao';
import dashboardOrcamento from './dashboard-orcamento';
import dashboardPagamento from './dashboard-pagamento';
import desdobramento from './desdobramento';
import dicionario from './dicionario';
import divisao from './divisao';
import endereco from './endereco';
import estado from './estado';
import estruturaUsuario from './estrutura-usuario';
import execucao from './execucao';
import exportacoes from './exportacoes';
import extensao from './extensao';
import filtroCliente from './filtro-cliente';
import funcionario from './funcionario';
import fluxoAprovacao from './workflow-cadastro';
import geracaoExportacao from './geracao-exportacao';
import grupoProduto from './grupo-produto';
import historicoVendas from './negociacao/historico-vendas';
import importacoes from './importacoes';
import linhasInvestimento from './linhas-investimento';
import loja from './loja';
import margemcontribuicao from './margem-contribuicao';
import metadado from './metadado';
import metas from './metas';
import nivelCliente from './nivel-cliente';
import nivelProduto from './nivel-produto';
import orcamento from './orcamento-cad';
import orcamentoListagem from './orcamento-listagem';
import orcamentoConfiguracao from './orcamento-configuracao';
import pagamentoCriacao from './pagamento-criacao';
import pagamentoGestao from './pagamento-gestao';
import pagamentoIntegracao from './pagamento-integracao';
import parametrizacaoAcao from './parametrizacao-acao';
import parametrizacaoCliente from './parametrizacao-cliente';
import parametrizacaoOrcamento from './parametrizacao-orcamento';
import perfil from './perfil';
import planejamentoAcaoConfiguracao from './planejamento-acao-configuracao';
import planejamentoAcaoCadastro from './planejamento-acao-cadastro';
import planejamentoAcaoListagem from './planejamento-acao-listagem';
import planejamentoMaterial from './planejamento-material';
import planejamentoPeca from './planejamento-peca';
import planejamentoTatico from './planejamento-tatico';
import planejamentoTaticoArquivo from './planejamento-tatico-arquivo';
import planejamentoTaticoMaterial from './planejamento-tatico-material';
import produto from './produto';
import rateioOrcamento from './orcamento-rateio';
import orcamentoTipoVerba from './orcamento-tipo-verba';
import regiao from './regiao';
import reivindicacao from './reivindicacao';
import representante from './representante';
import representanteCliente from './representante-cliente';
import representanteLogado from './representante-logado';
import reporteTatico from './reporte-tatico';
import roi from './negociacao/roi';
import sellIn from './sell-in';
import sellOut from './sell-out';
import ssoGrupo from './sso/grupo';
import ssoRole from './sso/role';
import ssoUsuario from './sso/usuario';
import termoAceite from './termo-aceite';
import tipoAcao from './tipo-acao';
import tipoBeneficio from './tipo-beneficio';
import tipoInvestimento from './tipo-investimento';
import tipoOrcamento from './tipo-orcamento';
import transferencia from './transferencia';
import transferenciaPosse from './controlador-trade/transferencia-posse';
import transferenciaPosseDefinitiva from './controlador-trade/transferencia-posse-definitiva';
import uploadReivindicacao from './upload-reivindicacao';
import unidadeMedida from './unidade-medida';
import usuario from './usuario';
import usuarioCliente from './usuario-cliente';
import usuarioLogado from './usuario-logado';
import usuarioUnidadeNegocio from './usuario-unidade-negocio';
import workflowAcao from './workflow-acao';
import workflowAcordo from './workflow-acordo';
import workflowApuracao from './workflow-apuracao';
import workflowApuracaoReivindicacao from './workflow-apuracao-reivindicacao';
import workflowAjusteVerba from './workflow-ajuste-verba';
import workflowOrcamento from './workflow-orcamento';
import workflowPassos from './workflow-passos';
import workflowPlanejamento from './workflow-planejamento';
import workflowTransferencia from './workflow-transferencia';
import workspaceFiltros from './workspace-filtros';
import relatorioPendencias from './relatorio/pendencias';
import historicoRelatorio from './relatorio/historico-relatorio';
import organograma from './relatorio/organograma';
import relatorioAcordo from './relatorioAcordo';

function plugin(Vue) {
  Vue.prototype.$api = {
    acordo,
    acessoUsuario,
    agendamento,
    ajusteVerba,
    alcada,
    anoFiscal,
    anoFiscalRelatorio,
    apuracaoAcaoListagem,
    apuracaoCrescimento,
    apuracaoFixo,
    apuracaoGestao,
    apuracaoTabloide,
    apuracoesVencidas,
    apuracaoNegociacaoPreco,
    apuracaoPositivacao,
    apuracaoReprocessamento,
    bloqueioSistema,
    cacheManager,
    carteiraCliente,
    calendario,
    cidade,
    cep,
    centroCusto,
    cliente,
    clienteCarteiraImplicita,
    configuracao,
    configuracaoNegociacao,
    configuracaoPlanejamento,
    configuracaoWorkflowAprovacao,
    configuracaoWorkflowContrato,
    contaCorrente,
    contrato,
    contratoLoja,
    controladorTrade,
    dashboardApuracao,
    dashboardGerencial,
    dashboardNegociacao,
    dashboardOrcamento,
    dashboardPagamento,
    desdobramento,
    dicionario,
    divisao,
    endereco,
    estado,
    estruturaUsuario,
    execucao,
    exportacoes,
    extensao,
    filtroCliente,
    fluxoAprovacao,
    funcionario,
    geracaoExportacao,
    grupoProduto,
    historicoVendas,
    historicoRelatorio,
    importacoes,
    linhasInvestimento,
    loja,
    margemcontribuicao,
    metadado,
    metas,
    nivelCliente,
    nivelProduto,
    orcamento,
    orcamentoListagem,
    orcamentoConfiguracao,
    orcamentoTipoVerba,
    pagamentoCriacao,
    pagamentoGestao,
    pagamentoIntegracao,
    parametrizacaoAcao,
    parametrizacaoCliente,
    parametrizacaoOrcamento,
    perfil,
    planejamentoAcaoConfiguracao,
    planejamentoAcaoCadastro,
    planejamentoAcaoListagem,
    planejamentoMaterial,
    planejamentoPeca,
    planejamentoTatico,
    planejamentoTaticoArquivo,
    planejamentoTaticoMaterial,
    produto,
    redefinicaoEmailUsuario,
    rateioOrcamento,
    regiao,
    representante,
    representanteCliente,
    representanteLogado,
    reporteTatico,
    roi,
    sellIn,
    sellOut,
    ssoUsuario,
    ssoGrupo,
    ssoRole,
    termoAceite,
    tipoAcao,
    tipoBeneficio,
    tipoInvestimento,
    tipoOrcamento,
    transferencia,
    transferenciaPosse,
    transferenciaPosseDefinitiva,
    unidadeMedida,
    usuario,
    usuarioCliente,
    usuarioLogado,
    usuarioUnidadeNegocio,
    workflowAcao,
    workflowAcordo,
    workflowApuracao,
    workflowApuracaoReivindicacao,
    workflowAjusteVerba,
    workflowOrcamento,
    workflowPassos,
    workflowPlanejamento,
    workflowTransferencia,
    workspaceFiltros,
    reivindicacao,
    relatorioPendencias,
    uploadReivindicacao,
    organograma,
    relatorioAcordo,
  };
}

if (typeof window !== 'undefined' && window.Vue) { // eslint-disable-line no-undef
  window.Vue.use(plugin); // eslint-disable-line no-undef
}

// module.exports = plugin;
export default plugin;



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/index.js